export type ParentType = 'MALE' | 'FEMALE' | 'SELF' | 'POPULATION' | 'CLONAL';

export const ParentType = {
    MALE: 'MALE' as ParentType,
    FEMALE: 'FEMALE' as ParentType,
    SELF: 'SELF' as ParentType,
    POPULATION: 'POPULATION' as ParentType,
    CLONAL: 'CLONAL' as ParentType
};
